import React from "react";
import { Preloader } from "@smartsuite/react-ui/lib";
export const ExcalidrawLoading = (props) => {
    const { width, height } = props;
    return (React.createElement("div", { className: "ss-excalidraw-wrapper" },
        React.createElement("div", { className: "ss-excalidraw-loading", style: {
                width: `${width || 200}px`,
                height: `${height || 200}px`,
            } },
            React.createElement(Preloader, { color: "primary", backdrop: false, isEmbed: false }))));
};
